import NotifyContext from './Context';
import { useContext } from 'react';

const useNotify = () => useContext(NotifyContext);

export default useNotify;
